module.exports = __webpack_public_path__ + "img/q_icon.7228a361.png";